export default class TimerTasksUtil
{
	static timers = {};
	
	static addTimer(_id,_delay,handler,_repeatCount = 0)
	{
		if(_repeatCount == 0)
		{
			var timer=setInterval(handler,_delay);
			TimerTasksUtil.timers[_id] = timer;	
		}
		else
		{
			var _id = setTimeout(function(){clearTimeout(_id);handler();},_delay);
		}
		
	}
	
	static cancelTimer(_id)
	{
		if(TimerTasksUtil.timers.hasOwnProperty(_id))
		{
			clearInterval(TimerTasksUtil.timers[_id]);
			delete TimerTasksUtil.timers[_id];
		}
	}

}



// WEBPACK FOOTER //
// ./src/utils/TimerTasksUtil.js